export const environment = {
  production: true,
  buildId: '4201421886925061',
  configFile: 'config.json',
};
